import { render } from "./Hero.vue?vue&type=template&id=19f146de&scoped=true"
import script from "./Hero.vue?vue&type=script&lang=js"
export * from "./Hero.vue?vue&type=script&lang=js"

import "./Hero.vue?vue&type=style&index=0&id=19f146de&scoped=true&lang=css"

import exportComponent from "/home/runner/work/yohom_cp/yohom_cp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f146de"]])

export default __exports__